import React from 'react';
import { Sparkles, GraduationCap, Bike, ShieldCheck, Zap, Award, Newspaper } from 'lucide-react';

/**
 * Ticker défilant infini horizontal.
 * - Reprend les arguments clés du produit (gratuit, ETM 2026, moniteurs ECSR…)
 * - Pivot magazine juin 2026 : on a retiré la mention "770+ questions officielles"
 *   au profit des arguments magazine (9 dossiers ETM, 31 enquêtes, 72 articles
 *   satellites). Cohérent avec le nouveau positionnement « sans QCM à rallonge ».
 * - Performant : pure CSS animation `c2r-marquee` sur translateX
 * - Pause au hover sur desktop, masqué en mode oral / impression
 * - Respecte prefers-reduced-motion (animation désactivée)
 */
export function MarqueeTicker() {
  const items = [
    { icon: Sparkles,      text: 'Gratuit pour tous les candidats' },
    { icon: Bike,          text: 'AM · A1 · A2 · Passerelle · 125 (B) · L5e' },
    { icon: GraduationCap, text: 'Programme officiel 2026 · 9 thèmes obligatoires' },
    { icon: Newspaper,     text: '9 dossiers ETM · 31 enquêtes magazine' },
    { icon: ShieldCheck,   text: 'Sans pub, sans tracking, sans score' },
    { icon: Award,         text: 'Pensé par des moniteurs ECSR' },
    { icon: Zap,           text: 'Épreuves Plateau · Circulation · Trajectoires' },
  ];

  const loop = [...items, ...items, ...items];

  return (
    <div
      className="c2r-marquee hide-in-oral"
      role="marquee"
      aria-label="Arguments clés CODE 2 ROUES"
      data-testid="home-marquee"
    >
      <div className="c2r-marquee__track" aria-hidden="true">
        {loop.map((it, i) => (
          <span key={i} className="c2r-marquee__item">
            <it.icon className="w-3.5 h-3.5" />
            <span>{it.text}</span>
            <span className="c2r-marquee__sep" aria-hidden="true">•</span>
          </span>
        ))}
      </div>
      <span className="sr-only">
        {items.map((it) => it.text).join('. ')}
      </span>
    </div>
  );
}
